import { Route, Routes } from "react-router-dom";
import C8StaticData from "./C8StaticData/main";
import C8TimeSeries from "./C8TimeSeries/main";
import C8Transactions from "./C8Transactions/main";

export default function C8Routes() {
  return (
    <Routes>
      <Route path="c8_static_data/*" element={<C8StaticData />} />
      <Route path="c8_time_series/*" element={<C8TimeSeries />} />
      <Route path="c8_transactions/*" element={<C8Transactions />} />
    </Routes>
  );
}
